import { testingOverrideAllowsAllFeatures } from '../config/testingOverrides'

/**
 * Demo unlock (R35 PD2/PD9/PD13): a per-workspace switch
 * (`workspaces/{id}.demoUnlock.enabled`) that lifts plan gates, limits and credit
 * charges only. It never widens a role, membership or identity check, and the apps
 * show no "Demo" badge.
 *
 * There is deliberately no project-id check on the client: the server
 * (`functions-common/src/config/demoUnlock.ts`) and Firestore rules enforce the
 * prod block, and only the Owner Console can set the flag. Mirrors the server's
 * `isDemoUnlocked` / `limitsLifted` semantics minus the project allow-list.
 */
export const isWorkspaceDemoUnlocked = (workspace: unknown): boolean =>
  (workspace as { demoUnlock?: { enabled?: unknown } } | null | undefined)?.demoUnlock?.enabled === true

/** Plan/limit/credit gates only: the testing override OR the workspace's demo unlock. */
export const limitsLiftedForWorkspace = (workspace: unknown): boolean =>
  testingOverrideAllowsAllFeatures() || isWorkspaceDemoUnlocked(workspace)
